import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { ALIGN_ITEMS_CENTER, ONE_HUNDRED_PERCENT_STRING, SPACING_S400 } from "common/types";
import { getString } from "common/uistringlabels/uiStringUtils";
import { UserPermissions } from "lib/services";
import moment from "moment-timezone";
import React, { FC } from "react";

import { UserAvatar } from "../UserAvatar";
import { Message } from "./types";

/**
 * Represents the properties for an individual message item in the conversation.
 * Extends the Message interface.
 * @interface
 * @extends {Message}
 * @property {string} className - The CSS class name applied to the message item for styling.
 */
interface MessageItemProps extends Message {
  className?: string;
}

export const MessageItem: FC<MessageItemProps> = ({ username, timestamp, message, className }) => {
  const currentUsername = UserPermissions.current.username;
  const displayName =
    username !== currentUsername ? getString("orderMessages.fromProcurement") : getString("orderMessages.fromSelf");

  const targetTimezone = moment.tz.guess(true); // Get the user's timezone

  return (
    <Row className={className}>
      <Col padding={{ top: SPACING_S400, bottom: SPACING_S400 }} width={ONE_HUNDRED_PERCENT_STRING}>
        <Row justifyContent="space-between" alignItems={ALIGN_ITEMS_CENTER} gridGap={32}>
          <UserAvatar login={username} name={displayName} />
          <Text color="gray">{moment(timestamp).tz(targetTimezone).format("MMMM Do YYYY, h:mm A (zz)")}</Text>
        </Row>
        <Row padding={{ left: "40px", top: SPACING_S400 }}>
          <Text>{message}</Text>
        </Row>
      </Col>
    </Row>
  );
};
